import React from 'react';
import SectionHeading from '../ui/SectionHeading';
import Tag from '../ui/Tag';
import StatCard from '../ui/StatCard';
import useReveal from '../../hooks/useReveal';
import { profile, skills, stats } from '../../data/content';
import './About.css';

const ACCENTS = ['violet', 'cyan', 'pink'];

export default function About() {
  const revealRef = useReveal();

  return (
    <section className="about" id="about">
      <div className="container reveal" ref={revealRef}>
        <SectionHeading eyebrow="01 · about" title="About" accent="Me" />
        <div className="about__grid">
          <div className="about__bio">
            <p>{profile.about}</p>
            <div className="about__skills">
              {skills.map((skill, i) => (
                <Tag key={skill} accent={ACCENTS[i % ACCENTS.length]}>
                  {skill}
                </Tag>
              ))}
            </div>
          </div>
          <div className="about__stats">
            {stats.map((stat) => (
              <StatCard key={stat.label} value={stat.value} label={stat.label} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
